module.exports = __webpack_public_path__ + "img/section2-2-mobile.5f490442.png";